module.exports = __webpack_public_path__ + "static/media/page_divider_colored.9472060e.svg";